import * as React from 'react'
import {useState} from 'react'
import '../../RedButtons.css'
import {ButtonState, ClientOrderNoticeAdminResult, Model, Unknown} from '../../types/types'
import {ClientConfig} from "../../types/clients";
import {useDispatch, useSelector} from "react-redux";
import Button from "./Button";
import {actionCreators} from "../../actions";
import {useParams} from "react-router-dom"

export interface Props {
  readonly greenButtonState: ButtonState
  readonly redButtonState: ButtonState
  readonly orderNoticeAdminResult: ClientOrderNoticeAdminResult | undefined
}

function VirtualServerControlPage(): JSX.Element {
  const selectedClientCode = useSelector<Model, string | undefined>(m => m.selectedClientCode);
  const clientSettings = useSelector<Model, ReadonlyArray<ClientConfig>>(m => m.clientSettings);
  const orderNoticeAdminResult = useSelector<Model, ClientOrderNoticeAdminResult | undefined>(m => m.orderNoticeAdminResult);
  const redButtonState = useSelector<Model, ButtonState>(m => m.redButtonState);
  const greenButtonState = useSelector<Model, ButtonState>(m => m.greenButtonState);
  const clientCodes = clientSettings.map(c => c.code);
  const [manualMode, setManualMode] = useState<boolean>(selectedClientCode === 'Unknown');
  const [manualCode, _] = useState<number>(Math.floor(100000 + Math.random() * 900000))
  const { virtualServerId } = useParams() as { virtualServerId: string | undefined };
  const dispatch = useDispatch();

  const clientSelected = (value: string) => {
    dispatch(actionCreators.selectClient(value));
    setManualMode(false);
  }

  const manualModeSelected = () => {
    dispatch(actionCreators.selectClient(undefined));
    setManualMode(true);
  }

  function renderSelector(text: string, onClick: (value: string) => void, selected: boolean): JSX.Element {
    return (
      <button
        type='button'
        key={text}
        onClick={(event) => onClick(event.currentTarget.value)}
        value={text}
        className={
          'button button--full_width ' +
          (selected ? 'button--active' : '')
        }
      >
        {text}
      </button>
    )
  }

  const message =
    redButtonState === 'Disabled'
      ? 'Red button in progress'
      : greenButtonState === 'Disabled'
      ? 'Green button in progress'
      : orderNoticeAdminResult === undefined
      ? null
          : orderNoticeAdminResult.resultMessage

  return (
    <div className='red-button-grid'>
      <h1 className='no-margin-top grid-header'>Red Buttons</h1>
      <h2 className=' grid-errors text-center'>{message}</h2>
      <div className='grid-clients'>
        <div className="margin-bottom-1em">
          {renderSelector('MANUAL', manualModeSelected, manualMode)}
        </div>
        <hr/>
        {clientCodes.map(c => renderSelector(c, clientSelected, c === selectedClientCode))}
      </div>
      <div className='text-center grid-red-button'>
        {selectedClientCode !== undefined || manualMode ? <Button virtualServerId={virtualServerId} key={selectedClientCode} buttonType='Suspend' code={!manualMode && selectedClientCode ? selectedClientCode : manualCode}/> : null}
      </div>
      <div className='text-center grid-green-button'>
        {selectedClientCode !== undefined || manualMode ? <Button virtualServerId={virtualServerId} key={selectedClientCode} buttonType='Release' code={!manualMode && selectedClientCode ? selectedClientCode : manualCode}/> : null}
      </div>
    </div>
  )
}

export default VirtualServerControlPage
